module.exports = __webpack_public_path__ + "static/media/empty.1487fa44.svg";